


export default function secondsToMin(seconds){
    seconds = Math.floor( seconds );
    var mins = seconds/60
    if (mins == 0) return seconds + ' secs'

    mins = Math.floor( mins );
    return mins + ' mins, ' + (seconds % 60) + ' secs' 
  }


  
